import { EPageType } from '@hotelplan/fdr.lib.page.available-pages';
import { useCurrentRoute } from '@hotelplan/fdr.lib.router.target-page';
import { WishlistViewType } from './fdr-wishlist.constants';

export function useWishlistViewType() {
  const { route: currentRoute } = useCurrentRoute();

  return currentRoute?.pageType === EPageType.WishlistCompare
    ? WishlistViewType.Compare
    : WishlistViewType.List;
}
